import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";

import { Button } from "@shared/ui/button";

import { localizedHref, resolveLang } from "../lib/links";

export function CTASection() {
  const { t, i18n } = useTranslation("landing");
  const lang = resolveLang(i18n.resolvedLanguage);

  return (
    <section className="bg-primary px-4 py-16 text-primary-foreground sm:px-6 sm:py-20 lg:px-8">
      <div className="mx-auto max-w-5xl overflow-hidden rounded-[2rem] border border-primary-foreground/20 bg-primary-foreground/10 p-8 text-center shadow-2xl backdrop-blur sm:p-12">
        <h2 className="font-serif text-4xl font-semibold leading-[1.1] tracking-[-0.04em] sm:text-5xl lg:text-6xl">
          {t("cta.heading")}
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-lg leading-8 text-primary-foreground/80">
          {t("cta.subheading")}
        </p>
        <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
          <Button
            className="bg-background text-foreground hover:bg-background/90"
            size="lg"
            asChild
          >
            <a href={localizedHref("/register", lang)}>
              {t("cta.primary")}
              <ArrowRight className="h-4 w-4 rtl:scale-x-[-1]" aria-hidden="true" />
            </a>
          </Button>
          <Button
            className="border-primary-foreground/40 bg-transparent text-primary-foreground hover:bg-primary-foreground/10 hover:text-primary-foreground"
            variant="outline"
            size="lg"
            asChild
          >
            <a href={localizedHref("/login", lang)}>{t("cta.secondary")}</a>
          </Button>
        </div>
      </div>
    </section>
  );
}

export const FinalCtaSection = CTASection;
export default CTASection;
